import { SECTION_TYPES } from '../sectionTypes';

/**
 * Resolves a normalized canonical line-item path to a form-field id.
 *
 * Today canonical and flattenData share the same array-indexed shape for
 * line items, so this is a passthrough. The function exists so that the
 * annotation pipeline has a single dispatch point — add transforms here
 * if the shapes ever diverge.
 *
 * Returns undefined when the path does not start with `line_items.`.
 */
export const resolveLineItemAnnotationItemId = (normalizedPath: string): string | undefined => {
  if (!normalizedPath.startsWith(`${SECTION_TYPES.LINE_ITEMS}.`)) {
    return undefined;
  }
  return normalizedPath;
};
